(function(){
    var eperTongji = {};
    eperTongji.CookieKey = "Eper-Tongji";
    eperTongji.CookieDomain = ".epermarket.com";
    eperTongji.CookieExpiredDays = 3650;  //365 days x 10
    eperTongji.BaseUrl = "https://tongji.epermarket.com"; 
    eperTongji.isSend = false;
    eperTongji.getUrl = function(){
        return window.location.href;
    };
    eperTongji.getNowUtcTime = function(){
        var d = new Date();
        return Math.floor(d.getTime() /1000);
    };    
    eperTongji.guid = function(){
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        var res = (S4() + S4() + "" + S4() + "" + S4() + "" + S4() + "" + S4() + S4() + S4());
        return res.toUpperCase();
    };   
    eperTongji.setCookie = function(name,msg,expireDays){
        var exp = new Date();
        exp.setTime(exp.getTime() + expireDays * 86400000); // 86400000 = 24 * 60 * 60 * 1000;
        document.cookie = name + "=" + msg + ";expires=" + exp.toGMTString() + ";domain="+eperTongji.CookieDomain+"; path=/";
    }; 
    eperTongji.getCookie = function(name){
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return arr[2];
        } else {
            return null;
        }
    };
    eperTongji.setVisitorKey=function(){
        let visitorKey = eperTongji.getCookie(eperTongji.CookieKey);
        if(!!!visitorKey){
            visitorKey = eperTongji.guid();
            eperTongji.setCookie(eperTongji.CookieKey,visitorKey,eperTongji.CookieExpiredDays);
        }
    };
    eperTongji.getData=function(isExit){
        let parser = new UAParser();
        let infoObj = parser.getResult();
        var obj = {
            VisitorKey:eperTongji.getCookie(eperTongji.CookieKey),
            VisitorSource:1,
            Platform:infoObj.os.name,
            Brand:"",
            Model:"",
            Browser:infoObj.browser.name+" "+infoObj.browser.version,
            Cpu:infoObj.cpu.architecture,
            Os:infoObj.os.name +" "+infoObj.os.version,
            ScreenSize:window.screen.width+"x"+window.screen.height,
            ColorDepth:window.screen.colorDepth,
            PageUrl:eperTongji.getUrl(),
            VisitTime: eperTongji.getNowUtcTime(),
            IsExit: isExit
        };
        return obj;
    };
    eperTongji.sendInfo = function () {
        eperTongji.isSend = true;
        let sendData = eperTongji.getData(false);
        $.ajax({
            url: eperTongji.BaseUrl + "/api/tongji/PageBrowse",
            //提交数据的类型 POST GET
            type:"POST",
            async:true,
            data:sendData,
            datatype: "json",
            //成功返回之后调用的函数             
            success:function(data,status,xhr){}
         });
    };
    eperTongji.exitSendInfo = function () {
        if (!eperTongji.isSend) {
            return;
        }
        let sendData = eperTongji.getData(true);
        $.ajax({
            url: eperTongji.BaseUrl + "/api/tongji/PageBrowse",
            //提交数据的类型 POST GET
            type: "POST",
            async: true,
            data: sendData,
            datatype: "json",
            //成功返回之后调用的函数             
            success: function (data, status, xhr) { }
        });
    };
    $(document).ready(function () {
        try {

            $(window).bind('beforeunload', function () {
                eperTongji.exitSendInfo();
            });

            eperTongji.setVisitorKey();
            setTimeout(() => {
                eperTongji.sendInfo();
            }, 1000);
        }
        catch (err) {
         //   console.log("eper-tongji error");
          //  console.log(err);
        }
        
    });
})();




// WEBPACK FOOTER //
// ./src/plugins/eper-tongji.js